module.exports = __webpack_public_path__ + "img/about-bg3.f2324058.png";